import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";

import { route } from "../../router/route";

import { errorHandler } from "../../util/errorHandler";
import LSBdCaption03 from "../molecules/text/linSeedKr/Bd/lsBdCaption03";
import LineSeedKrRg from "../atoms/text/lineSeedKr/lineSeedKrRg";

import LSBdBody02 from "../molecules/text/linSeedKr/Bd/lsBdBody02";
import LSBdDisplay02 from "../molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgCaption02 from "../molecules/text/linSeedKr/Rg/lsRgCaption02";
import BaseInfoApi from "../../api/baseInfo.api";

const FooterM = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [baseInfoData, setBaseInfoData] = useState({
    address: "경기도 군포시 엘에스로 143, 101동 3405호",
    businessNumber: "216-64-00626",
    ceo: "이동영",
    companyName: "핀라이브",
    createdAt: "2024-11-26T18:01:54.576Z",
    csCenter1: "010-4406-1831",
    csCenter2: "평일:  10:00 ~ 17:00",
    csCenter3: "토요일, 일요일, 공휴일 휴무",
    email: "finlive2024@gmail.com",
    id: 1,
    logoOriginFileName: "Group 1410117328 (1).png",
    logoServerFileName: "basic/0a47f38d-6490-45c3-8a69-f0a846d5fdfd.png",
    membershipPrice: 20000,
    reportNumber: "제2024-안양동안-1898호",
    tel: "010-4406-1831",
    updatedAt: "2024-12-10T05:33:35.810Z",
  });

  useEffect(() => {
    baseInfoFunc();
  }, []);

  const baseInfoFunc = async () => {
    try {
      const response = await BaseInfoApi.getInfo();

      const content = response.data.data.content;
      if (content) setBaseInfoData(content);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <FooterMSection>
      <FooterMWrapper>
        <img
          onClick={() => {
            navigate(`${route.home}`);
          }}
          style={{
            width: 120,
            height: 40,
            marginBottom: 27,
            cursor: "pointer",
          }}
          src="/assets/icons/logo_gh.png"
          alt="logo_gh"
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "0px 16px",
          }}
        >
          <MenuText
            onClick={() => {
              navigate(`${route.customer_service_terms_use}`);
            }}
          >
            이용약관
          </MenuText>
          <MenuText
            onClick={() => {
              navigate(`${route.customer_service_terms_privacy}`);
            }}
          >
            개인정보처리방침
          </MenuText>
          <MenuText
            onClick={() => {
              navigate(`${route.customer_service_notice}`);
            }}
          >
            공지사항
          </MenuText>
          <MenuText
            onClick={() => {
              navigate(`${route.customer_service_ask}`);
            }}
          >
            1:1 문의
          </MenuText>
          <MenuText
            onClick={() => {
              navigate(`${route.customer_service_faq}`);
            }}
          >
            FAQ
          </MenuText>
        </div>

        <LineSeedKrRg
          style={{
            fontSize: 12,
            lineHeight: "18px",
            color: "#626262",
            fontWeight: 400,
            margin: "24px 0px 30px 0px",
          }}
        >
          {baseInfoData.companyName} ㅣ 대표 : {baseInfoData.ceo} ㅣ
          사업자등록번호 : {baseInfoData.businessNumber}
          <br />
          주소: {baseInfoData.address} <br />
          통신판매업신고: {baseInfoData.reportNumber} <br />
          TEL : {baseInfoData.tel} ㅣ E-MAIL : {baseInfoData.email}
          <br />
          Copyright ⓒ 2024 핀라이브 All rights reserved.
        </LineSeedKrRg>

        <LSBdBody02
          style={{
            marginBottom: 8,
            color: "#101113",
          }}
        >
          CS CENTER
        </LSBdBody02>

        <LSBdDisplay02
          style={{
            marginBottom: 8,
            color: "#101113",
          }}
        >
          {baseInfoData.csCenter1}
        </LSBdDisplay02>

        <LSRgCaption02
          style={{
            color: "#575B65",
            marginBottom: 27,
          }}
        >
          {baseInfoData.csCenter2}
          <br />
          {baseInfoData.csCenter3}
        </LSRgCaption02>

      </FooterMWrapper>
    </FooterMSection>
  );
};

export default FooterM;

const FooterMSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9;
  position: relative;
`;

const FooterMWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f6f7f8;
  padding: 40px 20px;
`;

const MenuText = styled(LSBdCaption03)`
  cursor: pointer;

  color: #6f7480;

  &:hover {
    color: #0000c7;
  }
`;
